import Cookies from "js-cookie";
import React, { createContext, useEffect, useState } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid"; // Import UUID for generating unique IDs

const currentDate = new Date().toLocaleDateString("en-GB");
// Create a context
const DataContext = createContext();
let logoutCallback = null;
// Create a provider component
const DataProvider = ({ children }) => {
  const [loggedUserDetail, setLoggedUserDetail] = useState({});
  const [tenderGPTData, setTenderGPTData] = useState([]);
  const [resultGPTData, setResultGPTData] = useState([]);
  const [searchType, setSearchType] = useState("Tender");
  const [localIP, setLocalIP] = useState(null);
  const [history, setHistory] = useState([]);
  const [search, setSearch] = useState("");
  const [showSideBar, setShowShowSideBar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newSearch, setNewSearch] = useState("");
  const [lastSearch, setLastSearchData] = useState("");
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [maxScore, setmaxScore] = useState(0);
  const [resmaxScore, setresmaxScore] = useState(0);
  const [openLoginModal, setopenLoginModal] = useState(false);
  const [openLoginMessage, setopenLoginMessage] = useState("");
  const [ip, setIp] = useState("");
  const [openPrintModel, setopenPrintModel] = useState(null);
  const [tenderData, setTenderData] = useState([]);
  const [selectFromHistory, setSelectFromHistory] = useState(false);
  //FOR GET LOGIN OR LOGOUT
  const [isLoggedInTrue, setIsLoggedInTrue] = useState(false);
  // For close wallet popup after purchase
  const [isWalletPopupVisible, setIsWalletPopupVisible] = useState(false);


  const [isCallFromTenderPrice, setIsCallFromTenderPrice] = useState(false);
  const [isCallFromResultPrice, setIsCallFromResultPrice] = useState(false);

  //Samar
  const [TidOrTrid, setTidOrTrid] = useState(0);
  logoutCallback = setIsLoggingOut;
  //payments
  const [successCode, setsuccessCode] = useState("");
  const [orderId, setorderId] = useState("");

  const storageKey =
    searchType === "Tender"
      ? "tenderLocalStorageHistory"
      : "resultLocalStorageHistory";
  useEffect(() => {
    // setHistory(
    //   searchType === "Tender"
    //     ? Cookies.get("tenderGPTData") === undefined
    //       ? []
    //       : [...new Set([...JSON.parse(Cookies.get("tenderGPTData"))])]
    //     : Cookies.get("resultGPTData") === undefined
    //     ? []
    //     : [...new Set([...JSON.parse(Cookies.get("resultGPTData"))])]
    // );

    setHistory(JSON.parse(localStorage.getItem(storageKey)) || []);

    if (localStorage.getItem("logDetails") === null) {
      setIsLoggingOut(false);
    } else {
      setIsLoggingOut(true);
    }

    axios
      .get("https://api.ipify.org?format=json")
      .then((response) => {
        setIp(response.data.ip);
      })
      .catch((error) => console.error("Error fetching IP address:", error));
  }, []);
  useEffect(() => {
    console.log(searchType, "searchType");
    if (searchType === "Result")
      setHistory(JSON.parse(localStorage.getItem(storageKey)) || []);
  }, [searchType]);

  // Update history when tenderGPTData changes
  useEffect(() => {
    
    let storedHistory = JSON.parse(localStorage.getItem(storageKey)) || [];
    //  
    if (
      tenderGPTData?.length > 0 &&
      tenderGPTData?.at(tenderGPTData?.length - 1).TenderList?.length > 0 &&
      !selectFromHistory
    ) {
      // const newHistory = [
      //   ...new Set([...history, ...tenderGPTData.map((ele) => ele)]),
      // ];
      const storageKey =
        searchType === "Tender"
          ? "tenderLocalStorageHistory"
          : "resultLocalStorageHistory";

      // Fetch the existing data from localStorage
      // let storedHistory = JSON.parse(localStorage.getItem(storageKey)) || [];

      // Create a new history object with the current date
      let newHistoryEntry;
      // if (isCallFromTenderPrice === false) {
      newHistoryEntry = {
        thredId:
          storedHistory?.length > 0
            ? tenderGPTData.length === 1 &&
              tenderGPTData?.at(0).TenderList.length === 50 && !isCallFromTenderPrice
              ? uuidv4()
              // : TidOrTrid > 0 ? uuidv4() : storedHistory.at(storedHistory?.length - 1).thredId
              : TidOrTrid > 0 && tenderGPTData?.at(0).TenderList.length === 1 ? uuidv4() : storedHistory.at(storedHistory?.length - 1).thredId
            : uuidv4(),
        date: currentDate,
        history: tenderGPTData?.at(0)?.search,
        searchList: tenderGPTData,
        isfav: false,
      };
      if (
        storedHistory?.at(storedHistory?.length - 1)?.thredId !==
        newHistoryEntry?.thredId &&
        newHistoryEntry.searchList.length > 0


      ) {

        if (storedHistory?.at(storedHistory?.length - 1)?.history !== newHistoryEntry?.history) {
          storedHistory.push(newHistoryEntry);
        }

        // Add the new entry to the stored history array
        localStorage.setItem(storageKey, JSON.stringify(storedHistory));
        // console.log(storedHistory, tenderGPTData, "storedHistory, tenderGPTData");

        // Save the updated history array back to localStorage
        setHistory(storedHistory);
        Cookies.set("tenderGPTData", JSON.stringify(storedHistory));
        Cookies.set("tenderGPTDataHistory", JSON.stringify(storedHistory));
      } else {

        storedHistory = storedHistory.map((ele) =>
          ele.thredId === newHistoryEntry.thredId
            ? (ele = newHistoryEntry)
            : ele
        );
        // .filter((ele) => ele !== "");
        // Add the new entry to the stored history array
        localStorage.setItem(storageKey, JSON.stringify(storedHistory));
        // console.log(storedHistory, tenderGPTData, "storedHistory, tenderGPTData");

        // Save the updated history array back to localStorage

        setHistory(storedHistory);
        Cookies.set("tenderGPTData", JSON.stringify(storedHistory));
        Cookies.set("tenderGPTDataHistory", JSON.stringify(storedHistory));
      }
    } else {
      setSelectFromHistory(false);
    }

    //SET CALCULATION OF SCORE
    if (
      tenderGPTData?.length > 0 &&
      tenderGPTData?.at(tenderGPTData?.length - 1).TenderList?.length > 0
    ) {
      var highestScoreTender = 0;
      const filtertenderdat = tenderGPTData
        ?.filter(
          (item) =>
            item.searchId ===
            tenderGPTData?.at(tenderGPTData?.length - 1)?.searchId
        )
        ?.at(0)?.TenderList;

      if (filtertenderdat?.length > 0) {
        highestScoreTender = filtertenderdat?.reduce((max, tender) => {
          return parseFloat(tender.elastic_score) >
            parseFloat(max.elastic_score)
            ? tender
            : max;
        }).elastic_score;
      }

      setmaxScore(
        parseFloat(
          (Math.floor(parseFloat(highestScoreTender) * 100) / 100).toFixed(2)
        )
      );
    }
  }, [tenderGPTData]);
  //updateChange when resultGPTData chnages
  useEffect(() => {
    let storedHistory = JSON.parse(localStorage.getItem(storageKey)) || [];
    //  
    if (
      resultGPTData.length > 0 &&
      resultGPTData.at(resultGPTData.length - 1).ResultList.length > 0 &&
      !selectFromHistory
    ) {
      // const newHistory = [
      //   ...new Set([...history, ...tenderGPTData.map((ele) => ele)]),
      // ];
      const storageKey =
        searchType === "Tender"
          ? "tenderLocalStorageHistory"
          : "resultLocalStorageHistory";

      // Fetch the existing data from localStorage
      // let storedHistory = JSON.parse(localStorage.getItem(storageKey)) || [];

      // Create a new history object with the current date
      let newHistoryEntry;
      newHistoryEntry = {
        thredId:
          storedHistory?.length > 0
            ? resultGPTData.length === 1 &&
              resultGPTData?.at(0).ResultList.length === 50 && !isCallFromResultPrice
              ? uuidv4()
              : TidOrTrid > 0 && resultGPTData?.at(0).ResultList.length === 1 ? uuidv4() : storedHistory.at(storedHistory?.length - 1).thredId
            : uuidv4(),
        date: currentDate,
        history: resultGPTData?.at(0)?.search,
        searchList: resultGPTData,
        isfav: false,
      };
      if (
        storedHistory?.at(storedHistory?.length - 1)?.thredId !==
        newHistoryEntry?.thredId &&
        newHistoryEntry.searchList.length > 0
        && storedHistory?.at(storedHistory?.length - 1)?.history !== newHistoryEntry?.history //NEW ADDED
      ) {
        if (storedHistory?.at(storedHistory?.length - 1)?.history !== newHistoryEntry?.history) {
          storedHistory.push(newHistoryEntry);
        }

        // Add the new entry to the stored history array
        localStorage.setItem(storageKey, JSON.stringify(storedHistory));
        // console.log(storedHistory, tenderGPTData, "storedHistory, tenderGPTData");

        // Save the updated history array back to localStorage
        setHistory(storedHistory);
        Cookies.set("resultGPTData", JSON.stringify(storedHistory));
        Cookies.set("resultGPTDataHistory", JSON.stringify(storedHistory));
      } else {
        storedHistory = storedHistory.map((ele) =>
          ele.thredId === newHistoryEntry.thredId
            ? (ele = newHistoryEntry)
            : ele
        );
        // .filter((ele) => ele !== "");
        // Add the new entry to the stored history array
        localStorage.setItem(storageKey, JSON.stringify(storedHistory));
        // console.log(storedHistory, tenderGPTData, "storedHistory, tenderGPTData");

        // Save the updated history array back to localStorage

        setHistory(storedHistory);
        Cookies.set("resultGPTData", JSON.stringify(storedHistory));
        Cookies.set("resultGPTDataHistory", JSON.stringify(storedHistory));
      }
    } else {
      setSelectFromHistory(false);
    }
    if (
      resultGPTData.length > 0 &&
      resultGPTData.at(resultGPTData.length - 1).ResultList.length > 0
    ) {

      //set res  max calculation
      var highestScoreResult = 0;
      const filtertenderdat = resultGPTData
        ?.filter(
          (item) =>
            item.searchId ===
            resultGPTData?.at(resultGPTData?.length - 1)?.searchId
        )
        ?.at(0)?.ResultList;
      if (filtertenderdat?.length > 0) {
        highestScoreResult = filtertenderdat?.reduce((max, tender) => {
          return parseFloat(tender.elastic_score) >
            parseFloat(max.elastic_score)
            ? tender
            : max;
        }).elastic_score;
      }

      setresmaxScore(
        parseFloat(
          (Math.floor(parseFloat(highestScoreResult) * 100) / 100).toFixed(2)
        )
      );
    }
  }, [resultGPTData]);

  // // Update history when resultGPTData changes
  // useEffect(() => {
  //   if (resultGPTData.length > 0) {
  //     const newHistory = [
  //       ...new Set([...history, ...resultGPTData.map((ele) => ele.search)]),
  //     ];
  //     setHistory(newHistory);
  //     Cookies.set("resultGPTData", JSON.stringify(resultGPTData));
  //     Cookies.set("resultGPTDataHistory", JSON.stringify(newHistory));
  //   }
  // }, [resultGPTData]);

  const clearDataContext = () => {
    setTenderGPTData([]);
    setTenderData([]);
    setSearch("");
    setLoading(false);
    setSearchType("Tender");
    setNewSearch(null);
    setResultGPTData([]);
    setHistory([]);
    setLocalIP(null);
    setLoggedUserDetail({});
    setLastSearchData("");
    setIsLoggingOut(false);
    setopenLoginModal(false);
    setopenLoginMessage("");
    setIp("");
    localStorage.clear();

  };

  return (
    <DataContext.Provider
      value={{
        tenderGPTData,
        setTenderGPTData,
        tenderData,
        setTenderData,
        search,
        setSearch,
        showSideBar,
        setShowShowSideBar,
        loading,
        setLoading,
        searchType,
        setSearchType,
        newSearch,
        setNewSearch,
        resultGPTData,
        setResultGPTData,
        history,
        setHistory,
        localIP,
        setLocalIP,
        loggedUserDetail,
        setLoggedUserDetail,
        lastSearch,
        setLastSearchData,
        clearDataContext,
        isLoggingOut,
        setIsLoggingOut,
        maxScore,
        setmaxScore,
        setresmaxScore,
        resmaxScore,
        openLoginModal,
        setopenLoginModal,
        openLoginMessage,
        setopenLoginMessage,
        ip,
        openPrintModel,
        setopenPrintModel,
        selectFromHistory,
        setSelectFromHistory,

        successCode, setsuccessCode,
        orderId, setorderId,
        isLoggedInTrue, setIsLoggedInTrue,
        isWalletPopupVisible, setIsWalletPopupVisible,
        isCallFromTenderPrice, setIsCallFromTenderPrice,
        isCallFromResultPrice, setIsCallFromResultPrice,
        TidOrTrid, setTidOrTrid
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export { DataContext, DataProvider };
export const getSetIsLoggingOut = () => logoutCallback;


// import Cookies from "js-cookie";
// import React, { createContext, useEffect, useState } from "react";
// import axiosMain from "../axiosMain";
// import axios from "axios";

// // Create a context
// const DataContext = createContext();

// // Create a provider component
// const DataProvider = ({ children }) => {
//   const [loggedUserDetail, setLoggedUserDetail] = useState({});

//   const [tenderGPTData, setTenderGPTData] = useState([]);
//   const [resultGPTData, setResultGPTData] = useState([]);
//   const [searchType, setSearchType] = useState("Tender");
//   const [localIP, setLocalIP] = useState(null);
//   const [history, setHistory] = useState([]);
//   const [tenderData, setTenderData] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showSideBar, setShowShowSideBar] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [newSearch, setNewSearch] = useState(""); // Track the current search term
//   const [lastSearch, setLastSearchData] = useState("");
//   const [isLoggingOut, setIsLoggingOut] = useState(false);
//   const [maxScore, setmaxScore] = useState(0);
//   const [resmaxScore, setresmaxScore] = useState(0);
//   const [openLoginModal, setopenLoginModal] = useState(false);
//   const [openLoginMessage, setopenLoginMessage] = useState("");
//   const [ip, setIp] = useState("");
//   const [openPrintModel, setopenPrintModel] = useState(null);

//   useEffect(() => {
//     setHistory(
//       searchType === "Tender"
//         ? Cookies.get("tenderGPTData") === undefined
//           ? []
//           : [...new Set([...JSON.parse(Cookies.get("tenderGPTData"))])]
//         : Cookies.get("resultGPTData") === undefined
//         ? []
//         : // ...resultGPTData?.map((ele) => ele.search),
//           [...new Set([...JSON.parse(Cookies.get("resultGPTData"))])]
//     );
//     if (localStorage.getItem("logDetails") === null) {
//       setIsLoggingOut(false);
//     } else {
//       setIsLoggingOut(true);
//     }
//     axios
//       .get("https://api.ipify.org?format=json")
//       .then((response) => {
//         setIp(response.data.ip);
//       })
//       .catch((error) => console.error("Error fetching IP address:", error));
//   }, []);

//   useEffect(() => {
//     if (history?.length > 0) {
//       Cookies.set(
//         "tenderGPTDataHistory",
//         JSON.stringify([
//           ...new Set([...history, ...tenderGPTData?.map((ele) => ele.search)]),
//         ])
//       );
//       Cookies.set("tenderGPTData", JSON.stringify(tenderGPTData));
//     }
//
//     Cookies.set("tenderGPTData", JSON.stringify(tenderGPTData));
//     console.log(tenderGPTData, "tenderGPTDatatenderGPTData");
//   }, [tenderGPTData]);

//   useEffect(() => {
//     if (history?.length > 0) {
//       Cookies.set(
//         "resultGPTDataHistory",
//         JSON.stringify([
//           ...new Set([...history, ...resultGPTData?.map((ele) => ele.search)]),
//         ])
//       );
//       Cookies.set("resultGPTData", JSON.stringify(resultGPTData));
//     }
//   }, [resultGPTData]);

//   function deleteAllCookies() {
//     const cookies = document.cookie.split(";");

//     for (let i = 0; i < cookies.length; i++) {
//       const cookie = cookies[i];
//       const eqPos = cookie.indexOf("=");
//       const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
//       document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
//     }
//   }
//   const clearDataContext = () => {
//     setTenderGPTData([]);
//     setTenderData([]);
//     setSearch("");
//     setLoading(false);
//     setSearchType("Tender");
//     setNewSearch(null);
//     setResultGPTData([]);
//     setHistory([]);
//     setLocalIP(null);
//     setLoggedUserDetail({});
//     setLastSearchData("");
//     setIsLoggingOut(false);
//     setopenLoginModal(false);
//     setopenLoginMessage("");
//     setIp("");
//   };
//   // useEffect(() => {
//   //   // axiosMain
//   //   //   .get(
//   //   //     `http://common.tendertiger.co.in/api/Common/searchHistory?userDetailId=984028&searchFrom=${
//   //   //       searchType === "Tender" ? "tenderai" : "resultai"
//   //   //     }`
//   //   //   )
//   //   //   ?.then((res) => {
//   //   // console.log(res.data);
//   //   // if (
//   //   //   res.data.length >
//   //   //   [
//   //   //     ...JSON.parse(
//   //   //       Cookies.get(
//   //   //         searchType === "Tender"
//   //   //           ? "tenderGPTDataHistory"
//   //   //           : "resultGPTDataHistory"
//   //   //       )
//   //   //     ),
//   //   // //   ].length
//   //   // // ) {
//   //   // if (tenderData.length > 0) {

//   //   //       searchType === "Tender"
//   //   //         ? Cookies.set(
//   //   //             "tenderGPTDataHistory",
//   //   //             JSON.stringify([
//   //   //               ...new Set([
//   //   //                 ...(JSON.parse(Cookies.get("tenderGPTDataHistory")) || "[]"),
//   //   //                 res.data,
//   //   //               ]),
//   //   //             ])
//   //   //           )
//   //   //         : Cookies.set(
//   //   //             "resultGPTDataHistory",
//   //   //             JSON.stringify([
//   //   //               ...new Set([
//   //   //                 ...(JSON.parse(Cookies.get("resultGPTDataHistory")) || "[]"),
//   //   //                 res.data,
//   //   //               ]),
//   //   //             ])
//   //   //           );
//   //   //       // }
//   //   //     })
//   //   //     ?.catch((err) => console.log(err));
//   //   //   Cookies.set("resultGPTData", JSON.stringify(resultGPTData));
//   // }, [searchType]);
//   // useEffect(() => {
//   //   searchType === "Tender"
//   //     ? Cookies.set("tenderGPTDataHistory", JSON.stringify(history))
//   //     : Cookies.set("resultGPTDataHistory", JSON.stringify(history));
//   //   // Cookies.set("history", JSON.stringify(history));
//   // }, [history]);

//   return (
//     <DataContext.Provider
//       value={{
//         tenderGPTData,
//         setTenderGPTData,
//         tenderData,
//         setTenderData,
//         search,
//         setSearch,
//         showSideBar,
//         setShowShowSideBar,
//         loading,
//         setLoading,
//         searchType,
//         setSearchType,
//         newSearch,
//         setNewSearch,
//         resultGPTData,
//         setResultGPTData,
//         history,
//         setHistory,
//         localIP,
//         setLocalIP,
//         loggedUserDetail,
//         setLoggedUserDetail,
//         lastSearch,
//         setLastSearchData,
//         deleteAllCookies,
//         clearDataContext,
//         isLoggingOut,
//         setIsLoggingOut,
//         maxScore,
//         setmaxScore,
//         setresmaxScore,
//         resmaxScore,
//         openLoginModal,
//         setopenLoginModal,
//         openLoginMessage,
//         setopenLoginMessage,
//         ip,
//         openPrintModel,
//         setopenPrintModel,
//       }}
//     >
//       {children}
//     </DataContext.Provider>
//   );
// };

// export { DataContext, DataProvider };
